module.exports = __webpack_public_path__ + "img/deal2.4518a97d.png";